import { Component, ElementRef, inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../elements/breadcrumb/breadcrumb.component';
import { PaginationComponent } from '../elements/pagination/pagination.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { HttpServiceService } from '../services/http-service.service';
import { NgxToastrService } from '../_services/ngx-toastr/ngx-toastr.service';
import { MatSortModule, Sort } from '@angular/material/sort';
import { Offcanvas } from 'bootstrap';
import { Select2, Select2Data } from 'ng-select2-component';
import { LoadingService } from '../services/loading.service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { USER_PERMISSIONS, APP_CONSTANTS } from '../app.constants';
import { LocalStorageService } from '../services/local-storage.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { debounceTime, distinctUntilChanged, filter, Subject, Subscription, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-tickets',
  imports: [ReactiveFormsModule, PaginationComponent, BreadcrumbComponent, MatSortModule, Select2, NgIf, CKEditorModule, NgFor, NgSelectModule, NgClass, DatePipe],
  templateUrl: './tickets.component.html',
  styleUrl: './tickets.component.css'
})
export class TicketsComponent {
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: 'Service Requests',
    breadcrumb_url : '/admin'
  }
  addTicketForm! : FormGroup;
  updateStatusForm!: FormGroup;
  active = 1;
  page: any = 1;
  totalRows: number = 20;
  totalPage: any = 0;
  allData: any = [];
  private httpService = inject(HttpServiceService);
  private authService = inject(LocalStorageService);
  loadingService = inject(LoadingService);
  allUsers = [
    {
      category: "Inspection",
      sub_category: "A/C",
      short_description: 'paul',
      created_date: '10/10/2011',
      need_by_date: "14/01/2015",
      approximate_cost: '2011',
      priority: 'Medium',
      status: "Pending",
      description: "test",
      property: "Testing"
    }
  ];
  offset_limit: number = 20;
  orderData: any;
  ticketadd_edit : boolean = false;
  viewTicket: boolean = false;
  @ViewChild('addTicketButton') offcanvas!: ElementRef;
  @ViewChild('viewTicketOffcanvas') viewOffcanvas!: ElementRef;
  private offcanvasInstance: Offcanvas | null = null;
  private viewOffcanvasInstance: Offcanvas | null = null;
  defaultSubCategories = ["A/C", "Bills", "Carpentry","Cleaning","Electrical","False Ceiling","Gas","Property Inspection","Inventory Check","Mediaroom","OutsideGardening","Painting","Plumbing","Polishing","Geyser","Mirrors","Windows &amp; Doors", "Rent Collection","Others"];
  subCategories: Select2Data = [];
  Editor: any = ClassicEditor;
  private modalService= inject(NgbModal);
  defaultStatusValues : string[] = ['Open', 'Archived', 'Pending', 'Work in Progress', 'Closed'];
  searchInput$ = new Subject<string>();
  properties: Select2Data = [];
  private lastSearchTermSubscription? : Subscription;
  private createTicketSubscription?: Subscription;
  private getAllTicketsSubscription?: Subscription;
  private getTicketDetailsByIdSubscription?: Subscription;
  private deleteTicketImageSubscription?:Subscription;
  private deleteServiceTicketSubscription? : Subscription;
  private searchFormSubscription?: Subscription;
  private getAllUsersSubscription?: Subscription;
  hasMore: boolean = true;
  lastSearchTerm: any;
  propertiesList: any = [];
  selectedFiles: any = [];
  disableClear: boolean = false;
  searchForm!: FormGroup;
  users: Select2Data = [];
  isEditTicket : boolean = false;
  uploadedImages: any = [];
  pageCount : number = 1;
  sortBy : string = '';
  orderBy : string = '';
  selectedTicketDetails: any = null;
  private viewTicketDetailsSubscription?: Subscription;

  constructor(private fb: FormBuilder, private alertService: NgxToastrService){
    this.addTicketForm = this.fb.group({
      property_id : [null, [Validators.required]],
      category : ['' , [Validators.required] ],
      sub_category : ['' , [Validators.required]],
      description : ['', [Validators.required]],
      priority  : ['' , [Validators.required]],
      status:[''],
      short_description: ['', [Validators.required]],
      apprx_cost : [''],
      needed_at : [''],
      tenant_visible:[false],
      owner_visible : [false],
      files : [''],
      id : ['']
    });
    this.updateStatusForm = this.fb.group({
      update_status : [null, [Validators.required]]
    });

    this.searchForm = this.fb.group({
      name: [''],
      category: [null],
      status: [null],
      priority: [null],
      property_id: [null],
      managed_by: ['']
    })

    this.orderData = this.allUsers.slice();
  }

  ngOnInit(): void {
    this.getAllServiceRequests();
    this.getAllProperties();
    if(this.checkManagedByFilter) this.getAllUsers();
    for(let sub of this.defaultSubCategories){
       this.subCategories.push(
        {
          value: sub,
          label: sub,
          data: { name: sub }
        }
       )
    }
    this.lastSearchTermSubscription = this.searchInput$
          .pipe(
            debounceTime(300),
            filter(term => {
              const skip = term === this.lastSearchTerm;
              return !skip;
            }),
            tap((term) => {
              this.page = 1;
              this.hasMore = true;
              this.lastSearchTerm = term;
            }),
            switchMap(term => {
              let query = term ? "&name=" + term : '';
              return this.httpService.getAllProperties(1, 20, query);
            }
            )
          )
          .subscribe(results => {
            this.properties = [];
            this.propertiesList = results.data["properties"] ?? [];
            if (this.propertiesList.length >= results.data["total"]) {
              this.hasMore = false;
            }
            for (let resp of this.propertiesList) {
              this.properties.push(
                {
                  value: resp.uid,
                  label: resp.name,
                  data: { name: resp.name }
                }
              )
            }
          });
          this.searchFormSubscription = this.searchForm.get('name')?.valueChanges
                .pipe(
                  debounceTime(500),
                  distinctUntilChanged()
                )
                .subscribe(value => {
                  this.handleSearch(value);
                });
  }

  ngAfterViewInit() {
        setTimeout(() => {
          const offcanvasElement = this.offcanvas?.nativeElement;
          if (offcanvasElement) {
            this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
              backdrop: 'static',
              keyboard: false,
            });
          }

          const viewOffcanvasElement = this.viewOffcanvas?.nativeElement;
          if (viewOffcanvasElement) {
            this.viewOffcanvasInstance = Offcanvas.getOrCreateInstance(viewOffcanvasElement, {
              backdrop: 'static',
              keyboard: false,
            });
          }
        });
  }

  addTicketEvent(data : any){
    this.ticketPopupOpen();
  }

  ticketPopupOpen(){
    this.ticketadd_edit = !this.ticketadd_edit;
    if (this.offcanvasInstance) {
      this.offcanvasInstance.show();
    }
  }

  tikcetClose(){
    this.ticketPopupOpen();
    this.isEditTicket = false;
    if (this.offcanvasInstance) {
      this.offcanvasInstance.hide();
    }
  }

   getAllProperties(query: any = '') {
    this.httpService.getAllProperties(this.page, this.offset_limit).subscribe({
      next: (response) => {
        this.propertiesList = response.data["properties"] ?? [];
        if (this.propertiesList.length >= response.data["total"]) {
          this.hasMore = false;
        }
        this.properties = [];
        for (let resp of this.propertiesList) {
          this.properties.push(
            {
              value: resp.uid,
              label: resp.name,
              data: { name: resp.name }
            }
          )
        }
      }
    })
  }

  onScrollToEnd() {
    // Optional: For pagination / infinite scroll
    if (!this.hasMore) return;
    this.page += 1;
    this.offset_limit += 10;
    this.httpService.getAllProperties(this.page, this.offset_limit).subscribe(response => {
      let resp = response.data["properties"] ?? [];
      if (this.propertiesList.length >= response.data["total"]) {
        this.hasMore = false;
      }
      this.propertiesList = [...this.propertiesList, ...resp];
      this.properties = [];
      for (let resp of this.propertiesList) {
        this.properties.push(
          {
            value: resp.uid,
            label: resp.name,
            data: { name: resp.name }
          }
        )
      }
    });
  }

  uploadImages(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files) {
      this.selectedFiles = Array.from(inputElement.files);
    }
  }

  handleSearch(value: any, keepPage: string = '') {
    const searchData = this.searchForm.value;
    let query = '';
    for (let key in searchData) {
      if (searchData[key]) {
        let search_val = searchData[key];
        if(key == 'property_id'){
          search_val = search_val.value ?? "";
        }
        query += `&${key}=${search_val}`;
      }
    }
    if(this.sortBy) query += `&sortBy=${this.sortBy}&orderBy=${this.orderBy}`;
    if (!keepPage) this.page = 1;
    if (query || !value) this.getAllServiceRequests(query);
    this.disableClear = (value || query) ? true : false;
  }

  resetSearchForm() {
    this.page = 1;
    this.sortBy = '';
    this.orderBy = '';
    this.searchForm.reset({
      inspection_status: null
    }, { emitEvent: false });
    this.getAllServiceRequests();
    this.disableClear = false;
  }

  getAllServiceRequests(query: any = '') {
    this.getAllTicketsSubscription = this.httpService.getAllServiceRequests(this.page, this.offset_limit, query).subscribe({
      next: (response) => {
         this.allUsers = response.data['serviceRequests'] ?? [];
         this.orderData = this.allUsers.slice();
         this.allData = this.paginator(this.orderData, this.page, this.totalRows, response["data"]?.total);
         this.totalPage = response.data.total;
         this.pageCount = response.data.pageCount;
      }
    });
  }

  onSubmit() {
    const formData = new FormData();
    this.selectedFiles.forEach((file: string | Blob, index: any) => {
      formData.append('files', file);
    });
    let uid : string = '';
    Object.keys(this.addTicketForm.controls).forEach((key) => {
      let value = this.addTicketForm.get(key)?.value;
      if(key=='property_id'){
        if(typeof(value) == 'string'){
          let selectedProperty = this.propertiesList.find((list: { name: any; }) => list.name == value);
          value = selectedProperty ? selectedProperty["uid"] : ""
        }else{
          value = value?.value ?? "";
        }
      }
      if(key == 'id') uid = value;
      if(value && key != 'id') formData.append(key, value);
    });
    if(this.isEditTicket){
      this.createTicketSubscription = this.httpService.updateServiceRequest(uid, formData).subscribe({
        next: (response) => {
          this.getAllServiceRequests();
          this.addTicketForm.reset();
          this.tikcetClose();
          this.selectedFiles = [];
          this.alertService.success(response.message, "toast-top-right");
        }
      });
    }else{
      this.createTicketSubscription = this.httpService.saveServiceRequest(formData).subscribe({
        next: (response) => {
          this.getAllServiceRequests();
          this.addTicketForm.reset();
          this.tikcetClose();
          this.selectedFiles = [];
          this.alertService.success(response.message, "toast-top-right");
        }
      });
    }
  }

  updateStatus(){

  }

  deleteImage(id : string){
    this.deleteTicketImageSubscription = this.httpService.deleteTicketsUploads(id).subscribe({
      next : (response) => {
        this.uploadedImages  = this.uploadedImages.filter((img: { id: string; }) => img.id !=id);
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  deleteTicket(id : string){
    this.deleteServiceTicketSubscription = this.httpService.deleteServiceTicket(id).subscribe({
      next : (response) => {
        this.getAllServiceRequests();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  viewImage(url : string){
    window.open(url , "_blank");
  }

  selectTicket(id : string){
    this.isEditTicket = true;
    this.getTicketDetailsByIdSubscription = this.httpService.getTicketDetailsById(id).subscribe({
      next : (response) => {
        this.uploadedImages  = response.data["uploads"];
        this.addTicketForm.patchValue({
          ...response.data,
          property_id : response.data['property_name']
        });
        this.addTicketForm.get('property_id')?.disable();
        this.ticketPopupOpen();
      }
    })
  }

  viewTicketDetails(id: string) {
    this.viewTicketDetailsSubscription = this.httpService.getTicketDetailsById(id).subscribe({
      next: (response) => {
        this.selectedTicketDetails = response.data;
        this.viewTicket = true;
        if (this.viewOffcanvasInstance) {
          this.viewOffcanvasInstance.show();
        }
      }
    });
  }

  closeViewTicket() {
    this.viewTicket = false;
    this.selectedTicketDetails = null;
    if (this.viewOffcanvasInstance) {
      this.viewOffcanvasInstance.hide();
    }
  }

  openCenter(content: TemplateRef<any>) {
    this.modalService.open(content, { centered: true,  backdrop: 'static' });
  }

  closeModal() {
    this.updateStatusForm.reset();
    this.modalService.dismissAll();
  }


  sortData(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      return;
    }
    this.sortBy = sort.active;
    this.orderBy = sort.direction;
    this.handleSearch('', "keepPage");
  }

  pageChange(e: any) {    //  Page Change funcation   ---------
    if (this.page == e) return;
    this.page = e;
    this.handleSearch('', 'keepPage');
  }

  paginator(items: any, current_page: any, per_page_items: any, total_records: any) {
    let page = current_page || 1,
      per_page = per_page_items || 10,
      offset = (page - 1) * per_page,

      paginatedItems = items,
      total_pages = Math.ceil(items.length / per_page);


    return {
      page: page,
      startPage: offset + 1,
      endPage: page * per_page,
      per_page: per_page,
      pre_page: page - 1 ? page - 1 : null,
      next_page: (total_pages > page) ? page + 1 : null,
      total: total_records,
      total_pages: total_pages,
      data: paginatedItems
    };
  }

  get checkAddServiceRequest(){
      return this.authService.checkPermission(USER_PERMISSIONS.SERVICE_REQUEST.SERVICE_REQUEST_ADD);
  }

  get checkEditServiceRequest(){
      return this.authService.checkPermission(USER_PERMISSIONS.SERVICE_REQUEST.SERVICE_REQUEST_EDIT);
  }

  get checkDeleteServiceRequest(){
      return this.authService.checkPermission(USER_PERMISSIONS.SERVICE_REQUEST.SERVICE_REQUEST_DELETE);
  }

  get checkManagedByFilter() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_MANAGED_BY_FILTER);
  }

  getAllUsers(){
    let query = `&role_identifier=${APP_CONSTANTS.USER_ROLES.PROPERTY_MANAGER}`;
    this.getAllUsersSubscription = this.httpService.getAllUsers(1, 200, query).subscribe({
      next : (response) => {
        for(let user of response.data.users){
            this.users.push(
              {
                value: user.uid,
                label: user.first_name + user.last_name,
                data: { name: user.first_name + user.last_name }
              }
            )
        }
      },
      error : (error) => {
        console.log(error);
      }
    })
  }

  ngOnDestroy(){
    this.lastSearchTermSubscription?.unsubscribe();
    this.createTicketSubscription?.unsubscribe();
    this.getAllTicketsSubscription?.unsubscribe();
    this.getTicketDetailsByIdSubscription?.unsubscribe();
    this.deleteTicketImageSubscription?.unsubscribe();
    this.deleteServiceTicketSubscription?.unsubscribe();
    this.searchFormSubscription?.unsubscribe();
    this.viewTicketDetailsSubscription?.unsubscribe();
    this.getAllUsersSubscription?.unsubscribe();
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
